/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from '../client/http-client';
import {
  type AccessTokenResponseDto,
  type Claims,
  type ErrorResponseDto,
  type JwtTokenResponseDto,
} from '../dto/data-contracts';

export class Token<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description JWT 토큰 발급 테스트
   *
   * @tags Token
   * @name CreateJwtToken
   * @summary JWT 토큰 발급 테스트
   * @request GET:/v1/token/token-test-create-jwt-token
   */
  createJwtToken = (
    query: {
      /**
       * 로그인 타입
       * @example "GOOGLE"
       */
      authType: string;
      /**
       * 유저 이메일
       * @example "cccv@cccv.to"
       */
      email: string;
      /** @default "60" */
      minute?: string;
      /**
       * 유저 역할 (인가 및 권한)
       * @example "CCCV_USER"
       */
      siteRoles: string;
      /** 유저 고유 식별자 */
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<JwtTokenResponseDto, ErrorResponseDto>({
      path: `/v1/token/token-test-create-jwt-token`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * @description NoPermission Test
   *
   * @tags Token
   * @name NoPermissionTest
   * @summary NoPermission Test
   * @request GET:/v1/token/token-test-noPermissionTest
   * @secure
   */
  noPermissionTest = (params: RequestParams = {}) =>
    this.http.request<string, ErrorResponseDto>({
      path: `/v1/token/token-test-noPermissionTest`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * @description AccessToken 갱신 테스트
   *
   * @tags Token
   * @name RenewAccessToken1
   * @summary AccessToken 갱신 테스트
   * @request GET:/v1/token/token-test-renew-access-token
   */
  renewAccessToken1 = (
    query: {
      /**
       * 로그인 타입
       * @example "GOOGLE"
       */
      authType: string;
      /**
       * 유저 이메일
       * @example "cccv@cccv.to"
       */
      email: string;
      refreshToken: string;
      /**
       * 유저 역할 (인가 및 권한)
       * @example "CCCV_USER"
       */
      siteRoles: string;
      /** 유저 고유 식별자 */
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AccessTokenResponseDto, ErrorResponseDto>({
      path: `/v1/token/token-test-renew-access-token`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * @description RequestAttribute Test
   *
   * @tags Token
   * @name RequestAttributeTest
   * @summary RequestAttribute Test
   * @request GET:/v1/token/token-test-requestAttribute
   * @secure
   */
  requestAttributeTest = (
    query: {
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, ErrorResponseDto>({
      path: `/v1/token/token-test-requestAttribute`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Token 유효성 검증 테스트
   *
   * @tags Token
   * @name ValidateJwtToken
   * @summary Token 유효성 검증 테스트
   * @request GET:/v1/token/token-test-validate-token
   */
  validateJwtToken = (
    query: {
      token: string;
      tokenType: 'ACCESS' | 'REFRESH';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<Claims, ErrorResponseDto>({
      path: `/v1/token/token-test-validate-token`,
      method: 'GET',
      query: query,
      ...params,
    });
}
